import {connect} from 'react-redux';
import React, {Component} from 'react';

import Sidebar from "./Sidebar";
import MainContainer from "./MainContainer";

class MainBuy extends Component {
    render() {
        return (
            <main className="clearfix">
                <MainContainer/>
                <Sidebar/>
            </main>
        )
    }
}

const mapStateToProps = state => {
    const objectPage = state.objectPage;

    return {
        objectPage
    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(MainBuy);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Buy/MainBuy.js